<template>
  <div class="comp-container">
    <h1>通知</h1>
  </div>
</template>

<script>
    export default {
        name: "notice"
    };
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// admin-notice.vue?72f9ed38